import { Link } from "react-router-dom";

/**
 * Compact quick-link tile: icon, title and one line of context on a single row.
 * The whole card is the link, so the old "View Grades ->" footer row was pure
 * duplication and is gone - `linkText` is kept for the accessible label.
 */
export default function DashboardCard({
  to,
  icon,
  iconBg,
  iconColor,
  hoverBorder,
  title,
  text,
  linkText,
}) {
  return (
    <Link
      to={to}
      aria-label={linkText || title}
      className="block group h-full"
    >
      <div
        className={`bg-ice-white rounded-xl shadow-sm p-3.5 border-2 border-transparent hover:shadow-md transition-all duration-200 h-full flex items-center gap-3 hover:border-${hoverBorder}`}
      >
        <div
          className={`rounded-full w-10 h-10 shrink-0 flex items-center justify-center bg-${iconBg}/10`}
        >
          {typeof icon === "string" ? (
            <i className={`${icon} text-lg text-${iconColor}`}></i>
          ) : (
            icon
          )}
        </div>

        <div className="min-w-0 flex-1">
          <h3 className="text-sm font-bold text-grey-dusk leading-tight truncate">
            {title}
          </h3>
          <p className="text-xs text-slate-cloud leading-tight truncate mt-0.5">
            {text}
          </p>
        </div>

        <svg
          className={`w-4 h-4 shrink-0 text-slate-cloud transition-colors group-hover:text-${hoverBorder}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </div>
    </Link>
  );
}
